<div class="tooltip-conatiner">
    <ng-container *ngTemplateOutlet="contentTemplate">
    </ng-container>
</div>
